import { Clickable, Col, Row, Text } from 'components';
import { theme } from 'lib';
import { useNavigate } from 'react-router-dom';

const Board = ({ data }) => {
  const navigate = useNavigate();

  function handleNavigation(user) {
    navigate(`/profile/${user.username}`);
  }

  if (!data?.length) return null;

  return (
    <Col start wid="100%">
      {data.map((x, i) => (
        <Row noFlex key={i} center>
          <Row noFlex wid="32px" marg="0 8px 0 0">
            <Text h3 col={theme.GREY_30}>
              0{i + 1}
            </Text>
          </Row>

          <Row between wid="100%">
            <Clickable onClick={() => handleNavigation(x.participant)}>
              <Text med wid="100%">
                {x.participant.name}
              </Text>
            </Clickable>

            <Text med align="right">
              {x.total}
            </Text>
          </Row>
        </Row>
      ))}
    </Col>
  );
};
export default Board;
